/**
 * Public app config for Create React App (build-time).
 *
 * Only variables prefixed with REACT_APP_ are inlined at compile time. Set them in:
 * - Local: `.env`, `.env.local`, or `.env.development.local` (gitignored)
 * - CI / Vercel: project Environment Variables for each environment (Production, Preview, etc.)
 *
 * Usage:
 *   import environment from "../environments/environment";
 *   `${environment.apiUrl}/api/...`
 *
 * Do not put secrets here — anything in REACT_APP_* is exposed in the client bundle.
 */
const trim = (value) => (typeof value === "string" ? value.trim() : "");

const trimTrailingSlash = (value) =>
  typeof value === "string" ? value.replace(/\/+$/, "") : "";

const isDev = process.env.NODE_ENV === "development";

const apiUrl =
  trimTrailingSlash(trim(process.env.REACT_APP_API_URL)) ||
  (isDev ? "http://localhost:6002" : "");

const frontendUrl =
  trimTrailingSlash(trim(process.env.REACT_APP_FRONTEND_URL)) ||
  (isDev ? "http://localhost:3000" : "");

if (!isDev && (!apiUrl || !frontendUrl)) {
  // eslint-disable-next-line no-console
  console.warn(
    "[config] REACT_APP_API_URL and REACT_APP_FRONTEND_URL should be set for this build (e.g. on Vercel).",
  );
}

const publicSitePathRaw =
  trim(process.env.REACT_APP_PUBLIC_SITE_PATH) || "";
const publicSitePath = publicSitePathRaw
  ? (publicSitePathRaw.startsWith("/") ? publicSitePathRaw : `/${publicSitePathRaw}`)
  : "";

const publicSiteBaseUrl = frontendUrl
  ? (publicSitePath ? `${trimTrailingSlash(frontendUrl)}${publicSitePath}` : trimTrailingSlash(frontendUrl))
  : "";

let frontendHost = "";
if (frontendUrl) {
  try {
    frontendHost = new URL(frontendUrl).host;
  } catch {
    frontendHost = "";
  }
}

const googleClientId = trim(process.env.REACT_APP_GOOGLE_CLIENT_ID);
const googleMapsEmbedKey = trim(process.env.REACT_APP_GOOGLE_MAPS_EMBED_KEY);
const googlePlacesPhotoKey = trim(
  process.env.REACT_APP_GOOGLE_PLACES_PHOTO_KEY,
);

const supportEmail = trim(process.env.REACT_APP_SUPPORT_EMAIL);
const legalEmail = trim(process.env.REACT_APP_LEGAL_EMAIL) || supportEmail;

const defaultQrPreviewUrl = trim(process.env.REACT_APP_DEFAULT_QR_PREVIEW_URL);
const defaultTicketImageUrl = trim(
  process.env.REACT_APP_DEFAULT_TICKET_IMAGE_URL,
);
const emailPoweredByLogoUrl = trim(process.env.REACT_APP_EMAIL_LOGO_URL);

const environment = {
  apiUrl,
  frontendUrl,
  frontendHost,
  publicSitePath,
  publicSiteBaseUrl,
  googleClientId,
  googleMapsEmbedKey,
  googlePlacesPhotoKey,
  supportEmail,
  legalEmail,
  defaultQrPreviewUrl,
  defaultTicketImageUrl,
  emailPoweredByLogoUrl,
};

export default environment;
